import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccountResolverService } from '../services/account-resolver.service';
import { AuthenticatedUserResolverService } from '@aveva/connect-web-core';

import { TrainingsComponent } from './trainings/trainings.component';
import { TrainingComponent } from './training.component';
import { ImportStudentsComponent } from './import/import-students/import-students.component';
import { AssignmentsListComponent } from './assignments/assignments-list/assignments-list.component';
import { TrainingGuard } from './training.guard';
import { AccountsListComponent } from './accounts/accounts-list/accounts-list.component';
import { HomeComponent } from './home/home.component';
import { DatasetListComponent } from './datasets/dataset-list/dataset-list.component';
import { MembershipListComponent } from './memberships/membership-list/membership-list.component';
import { AccountsAccessTokenComponent } from './accounts/accounts-access-token/accounts-access-token.component';
import { ConfigurationsListComponent } from './configurations/configurations-list/configurations-list.component';
import { HealthstatsComponent } from './healthstats/healthstats.component';
import { NamespacesListComponent } from './healthstats/namespaces-list/namespaces-list.component';
import { FoldersListComponent } from './healthstats/folders-list/folders-list.component';

const routes: Routes = [
  {
    path: 'training',
    component: TrainingComponent,
    resolve: {
      user: AuthenticatedUserResolverService,
      account: AccountResolverService
    },
    children: [{
      path: '',
      redirectTo: 'home',
      pathMatch: 'full'
    }, {
      path: 'home',
      component: HomeComponent
    }, {
      path: 'healthstats',
      component: HealthstatsComponent
    }, {
      path: 'trainings',
      component: TrainingsComponent
    }, {
      path: 'imports',
      component: ImportStudentsComponent
    }, {
      path: 'assignments',
      component: AssignmentsListComponent,
      canActivate: [TrainingGuard]
    }, {
      path: 'accounts',
      component: AccountsListComponent,
      canActivate: [TrainingGuard]
    }, {
      path: 'datasets',
      component: DatasetListComponent,
      canActivate: [TrainingGuard]
    }, {
      path: 'memberships',
      component: MembershipListComponent,
      canActivate: [TrainingGuard]
    }, {
      path: 'aat',
      component: AccountsAccessTokenComponent,
      canActivate: [TrainingGuard]
    }, {
      path: 'configurations',
      component: ConfigurationsListComponent,
      canActivate: [TrainingGuard]
    }, {
      path: 'namespaces',
      component: NamespacesListComponent
    }, {
      path: 'folders',
      component: FoldersListComponent
    }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrainingRoutingModule { }
